var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patent_apply"},[_c('div',{staticClass:"patent_title"},[_vm._v("长三角地区PCT专利申请量")]),_c('div',{staticStyle:{"width":"100%","height":"100px"},attrs:{"id":"barChart8"}}),_c('div',{staticStyle:{"width":"100%","height":"170px"},attrs:{"id":"barChart9"}})])
}]

export { render, staticRenderFns }